import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9dc6c68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-permission-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "member-permission__tips"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "member-permission__tips-ul" }, [
  /*#__PURE__*/_createElementVNode("li", null, "该成员将无法访问本空间"),
  /*#__PURE__*/_createElementVNode("li", null, "系统会保留该成员的空间数据。在该成员被移除之前，你可以再次启用")
], -1))
const _hoisted_4 = {
  key: 1,
  class: "member-permission__tips"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")

import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'disableOrEnableMember',
  props: {
    type: null,
    name: null
  },
  setup(__props: any) {

const props = __props as {
  type: string // enable|disable
  name: string
}


const isDisable = computed(() => {
  return props.type === 'disable'
})

return (_ctx: any,_cache: any) => {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NSpace = _resolveComponent("NSpace")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isDisable))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(" 是否禁用成员【" + _toDisplayString(props.name) + "】？禁用后： ", 1),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, " 是否启用成员【" + _toDisplayString(props.name) + "】？启用后，该成员将解除禁用状态，恢复在本空间的权限。 ", 1)),
    _createVNode(_component_NSpace, {
      class: "member-permission__footer",
      size: 16,
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_NButton, {
          type: _unref(isDisable) ? 'error' : 'primary',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(isDisable) ? '禁用' : '启用'), 1)
          ]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    })
  ]))
}
}

})